import { useEffect, useState } from "react";
import { useCurrentUser } from "@hooks/use-current-user";
import { getStoryblokStory } from "@utils/call-api/storyblok-call";
import StoryblokComponent from "@components/core/Storyblok/StoryblokComponent";
import { maternityHeaderInitStory } from "@utils/storyblok/initStories";
import { useLocale } from "@lib/i18n/navigation-pages-router";

function CatalogHeaderStory() {
  const user = useCurrentUser();
  const locale = useLocale();
  const canPreview = Boolean(user?.permissions?.includes("storyblok"));

  const [story, setStory] = useState(maternityHeaderInitStory);

  useEffect(() => {
    const fetchStoryblokStory = async () => {
      const storySlug = `common/maternity-header/${process.env.NEXT_PUBLIC_CUSTOMER}/maternity-header`;
      const storyParams = {
        language: locale,
        ...(canPreview && { version: "draft" }),
      };

      const data = await getStoryblokStory(storySlug, storyParams);

      setStory(data.story);
    };

    fetchStoryblokStory();
  }, [canPreview, locale]);

  if (!story) return null;

  return <StoryblokComponent story={story} />;
}

export default CatalogHeaderStory;
